<div class="btn-toolbar justify-content-center justify-content-md-end">
  <button type="button" class="btn btn-primary" (click)="clearEvent.emit()">
    {{ "buttons.clear" | msg | async }}
  </button>
  <button
    type="button"
    class="btn btn-danger ms-3"
    (click)="searchEvent.emit()"
    [disabled]="disabled"
  >
    <svg-icon
      src="../../../assets/images/icons/search.svg"
      [svgStyle]="{ 'width.px': 20, 'height.px': 20, stroke: 'white' }"
    ></svg-icon
    >{{ "buttons.search" | msg | async }}
  </button>
</div>
